import Text from 'components/_UI/Text';
import React from 'react';
import styled, { css } from 'styled-components';
import { FullyCentered } from 'styled/alignment/Center';
import colors from 'theme/colors';
import breakpoints from 'theme/breakpoints';
import { getCategoryIcon } from './categoryIconMap';

export default function CategoryCard({ data, onClick, selected }) {
    const CategoryIcon = getCategoryIcon(data?.icon);
    const iconColor = selected ? colors.occasionalPurple : colors.nightLight;

    return (
        <Container onClick={onClick} selected={selected}>
            <CategoryIcon size={28} color={iconColor} />
            <Label selected={selected}>{data?.name}</Label>
        </Container>
    );
}

const Container = styled(FullyCentered)`
    flex: 1;
    min-width: 100px;
    max-width: 140px;

    @media screen and (min-width: ${breakpoints.lg}) {
        flex: none;
        width: 120px;
    }
    height: auto;
    flex-direction: column;
    gap: 8px;
    padding: 16px 10px 14px;
    border-radius: 8px;
    border: 1px solid ${colors.night}18;
    background: ${colors.neutralLight};
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
        border-color: ${colors.occasionalPurple};
        background: ${colors.occasionalPurple}08;
        transform: translateY(-2px);
    }

    ${({ selected }) => selected && css`
        border: 1.5px solid ${colors.occasionalPurple};
        background: ${colors.occasionalPurple}10;
    `}
`;

const Label = styled.p`
    font-size: 14px;
    font-weight: 500;
    color: ${({ selected }) => selected ? colors.occasionalPurple : colors.nightLight};
    text-align: center;
    margin: 0;
    line-height: 1.3;
    word-break: break-word;
`;
